module.exports = __webpack_public_path__ + "static/media/ic-recognition-success.3209923f.svg";